import SpriteEditor from './SpriteEditor';

export default SpriteEditor;
